// An id safe inside url(#…) and CSS identifiers. React 18's useId() yields ":r0:", whose colons break url(#…)
// references, so they are removed (the result matches /^[a-zA-Z0-9_-]+$/ and stays unique per component instance).

import { useId } from "react";

export function useSvgId(): string {
  return useId().replace(/[^a-zA-Z0-9_-]/g, "");
}
